import { get } from 'src/axios/post'
import { reset, wait } from 'src/store'

const loggedInStates = () => {
  return [
    'file_categories',
    'needsReloading',
    'loading'
  ]
}

const defaultStates = () => {
  return {
    file_categories: [],
    needsReloading: true,
    loading: false
  }
}

export default {
  namespaced: true,
  state: defaultStates(),
  mutations: {
    reset (state) {
      reset(state, loggedInStates(), defaultStates())
    },
    setLoading (state, val) {
      state.loading = Boolean(val)
    },
    setNeedsReloading (state, val) {
      state.needsReloading = Boolean(val)
    },
    setFileCategories (state, categories) {
      state.file_categories = categories
      state.needsReloading = false
    },
    changeCategoryPosition (state, { from, to }) {
      state.file_categories.splice(to, 0, state.file_categories.splice(from, 1)[0])
    }
  },
  actions: {
    async getFileCategories ({ commit, state }) {
      if (state.loading || !state.needsReloading) {
        if (state.loading) {
          await wait(state, 'loading')
        }
        return
      }
      commit('setLoading', true)
      const { status, payload } = await get('v1/files/categories')
      commit('setLoading', false)
      if (status === 'success') {
        commit('setFileCategories', payload.categories || [])
      }
    }
  },
  getters: {
    getFileCategories: state => state.file_categories,
    needsReloading: state => state.needsReloading,
    isLoading: state => state.loading
  }
}
